import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { PlatformLocation } from "@angular/common";
import { Plan } from "@core/interfaces/entities";

@Component({
    selector: "app-benefits-selection-modal",
    templateUrl: "./benefits-selection-modal.component.html",
    styleUrls: ["./benefits-selection-modal.component.scss"],
    standalone: false,
})
export class BenefitsSelectionModalComponent {
    @Input() plan: Plan;

    benefitForm: UntypedFormGroup;

    @Output() selectionComplete = new EventEmitter();

    constructor(
        public activeModal: NgbActiveModal,
        private fb: UntypedFormBuilder,
        private location: PlatformLocation,
    ) {
        this.benefitForm = this.fb.group({
            benefitOption: [null, Validators.required],
        });
        location.onPopState(() => activeModal.close());
    }

    set selectedBenefit(benefit) {
        this.benefitForm.patchValue({ benefitOption: benefit });
    }

    emitSelectionComplete() {
        this.selectionComplete.emit({
            id: this.plan.id,
            benefitOption: this.benefitForm.get("benefitOption").value,
        });
        this.activeModal.close("done");
    }
}
